import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Input,
  Form,
  DatePicker,
  Typography,
  Space,
  Tag,
  message,
  Tooltip,
  Dropdown,
  Menu,
  Checkbox,
  Modal,
  Spin,
} from "antd";
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
  DownOutlined,
  CalendarOutlined,
  ReloadOutlined,
  DownloadOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "./EmailListing.css";
import { URL } from "../helper/Mainurl";
import ViewEmail from "./Email/ViewEmail";
import NewEmailSetup from "./Email/NewEmailSetup";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import { apiClient } from "../utils/apiClient";
const { RangePicker } = DatePicker;
const { Title, Text, Paragraph, Link } = Typography;

// Debounce hook
function useDebouncer(value, delay = 500) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debounced;
}

const EmailListing = () => {
  const token = localStorage.getItem("authToken"); // Get token from localStorage
  const [emails, setEmails] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebouncer(searchTerm, 500); // Debounced search
  const [dateRange, setDateRange] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editView, setEditView] = useState(false);
  const [modalVisible, setModalVisible] = useState(true);
  const [emailSetupStartStep, setEmailSetupStartStep] = useState(0);
  const [manualEdit, setManualEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [keywords, setKeywords] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState("Select Keyword");
  const [selectedFinalKeywords, setSelectedFinalKeywords] = useState([]);
  const [selectedkeywordsID, setSelectedkeywordsID] = useState(null);
  const [editingEmail, setEditingEmail] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [members, setMembers] = useState([]);
  const [filterDateRange, setFilterDateRange] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20); // Default page size
  const [totalEmails, setTotalEmails] = useState(0);
  const [calenderMeta, setCalenderMeta] = useState([]);
  const [priorityList, setPriorityList] = useState([]); // Stores the list of priorities
  const [selectedPriority, setSelectedPriority] = useState("Select Priority");
  const [screenLoading, setScreenLoading] = useState(false);

  const [selectedPriorityID, setSelectedPriorityID] = useState([]);
  const [memberToDelete, setMemberToDelete] = useState(null);
  const [initialKeyworkdsData, setInitialKeywordsData] = useState(null);
  const [emailAssistantSetupOptions, setEmailAssistantSetupOptions] =
    useState(null);

  const [attachmentModal, setAttachmentModal] = useState({
    visible: false,
    attachments: [],
  });
  const cleanUrl = (url) => url.replace(/\\\//g, "/");
  const [form] = Form.useForm();
  // Handle single selection
  const onSelectChange = (key) => {
    setSelectedRowKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };
  const handleMenuClick = (info) => {
    if (!priorityList || priorityList.length === 0) {
      console.error("Priority list is empty or not loaded.");
      return;
    }
    const selected = priorityList.find(
      (p) => String(p.id) === String(info.key)
    );
    if (selected) {
      setSelectedPriority(selected.label_name);
      setSelectedPriorityID([selected.id]);
    } else {
      console.error("Selected Priority Not Found. Key received:", info.key);
    }
  };
  const handleKeywordsMenuClick = (info) => {
    const selected = keywords.find((p) => String(p) === String(info.key));
    if (selected) {
      setSelectedKeywords(selected);
      setSelectedFinalKeywords([selected]);
    } else {
      console.error("Selected Keyword Not Found", info.key);
    }
  };
  // Handle Select All logic
  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingEmail(null);
  };
  const showDeleteModal = (members) => {
    setMemberToDelete(Array.isArray(members) ? members : [members]); // Ensure array
    setIsDeleteModalOpen(true);
  };
  const menuProps = {
    items: priorityList.map((item) => ({
      key: String(item.id),
      label: item.label_name,
    })),
    onClick: handleMenuClick,
  };
  const keywordsProps = {
    items: keywords.map((item) => ({
      key: item, // Using the string itself as the key
      label: item,
    })),
    onClick: handleKeywordsMenuClick,
  };
  const handleDeleteConfirm = async () => {
    if (!memberToDelete || memberToDelete.length === 0) return;
    try {
      const response = await fetch(`${URL}/v1/parsed-email/delete`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ids: memberToDelete.map(Number), // Convert IDs to numbers
        }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Failed to delete: ${errorData.message || response.statusText}`
        );
      }
      setEmails((prevEmails) =>
        prevEmails.filter((email) => !memberToDelete.includes(email.key))
      );
      message.success("Emails deleted successfully!");
      setSelectedRowKeys([]); // Clear selection
    } catch (error) {
      console.error("Error deleting emails:", error);
      message.error("Failed to delete emails. Please try again.");
    } finally {
      setIsDeleteModalOpen(false);
      setMemberToDelete([]); // Reset array
    }
  };
  const handleSave = async () => {};
  const handleCancelModal = () => {
    getData(currentPage);
    setIsModalVisible(false);
    setEditView(false);
  };
  const handleSelectAll = () => {
    if (selectedRowKeys.length === emails.length) {
      setSelectedRowKeys([]); // Deselect all
    } else {
      setSelectedRowKeys(emails.map((email) => email.key)); // Select all
    }
  };
  // Handle Individual Delete
  const handleDelete = (key) => {
    setEmails((prevEmails) => prevEmails.filter((email) => email.key !== key));
    message.success("Email deleted!");
  };
  // Handle Search Filter
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };
  // Handle Date Range Filter
  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) {
      setDateRange([]); // Reset if no date is selected
    } else {
      setDateRange([
        dates[0].format("YYYY-MM-DD"),
        dates[1].format("YYYY-MM-DD"),
      ]);
    }
  };
  const resetFilters = () => {
    setDateRange([]);
    setSelectedKeywords("Select Keyword");
    setSearchTerm("");
    setSelectedPriorityID([]);
    setSelectedPriority("Select Priority");
    setSelectedFinalKeywords([]);
    setCurrentPage(1); // Reset to first page
    getData(1, pageSize); // Fetch data with reset filters
  };
  // Fetch Emails from API
  const getData = async (page = 1) => {
    try {
      setLoading(true);
      const params = {};

      // Append date range
      if (dateRange[0]) params.start_date = dateRange[0];
      if (dateRange[1]) params.end_date = dateRange[1];

      // Append search term
      if (debouncedSearchTerm) params.search = debouncedSearchTerm;

      // Append selected keywords
      if (selectedFinalKeywords.length > 0) {
        params["keywords[]"] = selectedFinalKeywords;
      }

      // Append selected priority IDs
      if (selectedPriorityID.length > 0) {
        params["priority_id[]"] = selectedPriorityID;
      }
      const response = await apiClient.get(
        `/v1/parsed-email/parsed-events/${page}`,
        params
      );

      // fetch(
      //   `${URL}/v1/parsed-email/parsed-events/${page}?${queryParams.toString()}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      // if (!response.ok) throw new Error("Failed to fetch emails");
      // setLoading(false);
      const data = response.data;
      if (data.code === 200) {
        setLoading(false);
        // handle success (setEmails, etc.)
      } else {
        setLoading(false);
        throw new Error(data.message || "Failed to fetch emails");
      }

      const eventCount = data.data.events.length;
      const newPageSize = eventCount > 0 ? eventCount : 20;
      const transformedEmails = data.data.events.map((email, index) => ({
        key: email.id ?? `email-${index}`,
        subject: email.title || "No Subject",
        date: email.start_date || "Unknown Date",
        due: email.end_time ? moment(email.end_time).fromNow() : "No Due Date",
        read: email.is_read,
        event_id: email.event_id,
        attachment_urls: email.attachment_urls,
      }));
      setPageSize(20);
      setCurrentPage(page);
      setEmails(transformedEmails);
      const totalCount = Number(data.data.total_count || 0);
      setTotalEmails(totalCount);
    } catch (error) {
      setLoading(false);
      message.error("Error fetching emails");
      console.error(error);
    }
  };
  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
    getData(pagination.current);
  };
  useEffect(() => {
    // Only fetch when debouncedSearchTerm changes
    getData(currentPage);
  }, [
    dateRange,
    selectedKeywords,
    debouncedSearchTerm,
    filterDateRange,
    selectedPriorityID,
    currentPage,
    pageSize,
  ]);
  useEffect(() => {
    getCalenderMetaData();
    getKeywords();
  }, []);
  const getCalenderMetaData = async () => {
    try {
      const response = await apiClient.get(
        "/v1/calendar/get-calendar-metadata"
      );
      const data = response.data;
      if (data.code == 200) {
        setEmailAssistantSetupOptions(data?.data);
        setPriorityList(data.data.priority || []);
      }
    } catch (error) {
      console.error(
        "Error fetching calendar metadata:",
        error.response?.data || error.message
      );
    }
  };
  const getKeywords = async () => {
    try {
      setScreenLoading(true);
      const response = await apiClient.get("/v1/parsed-email/user/keywords");
      const data = response.data;
      if (!data.data.email_assistant_setup_details) {
        setModalVisible(true);
      } else {
        setModalVisible(false);
      }
      setInitialKeywordsData(data);
      setKeywords(data?.data?.keywords || []);

      if (data?.data?.date_range) {
        setFilterDateRange({
          start: data.data.date_range.start_date,
          end: data.data.date_range.end_date,
        });
      }
    } catch (error) {
      message.error("Error fetching keywords");
      console.error(error);
    } finally {
      setScreenLoading(false);
    }
  };
  const disabledDate = (current) => {
    console.log("disabledDate", filterDateRange);
    if (!filterDateRange) return false;
    const startDate = filterDateRange.start
      ? new Date(filterDateRange.start)
      : null;
    const endDate = filterDateRange.end ? new Date(filterDateRange.end) : null;
    return (
      (startDate && current.isBefore(startDate, "day")) ||
      (endDate && current.isAfter(endDate, "day"))
    );
    //   return current && current < moment().startOf('day');
  };
  const handleEdit = async (key) => {
    try {
      const response = await fetch(`${URL}/v1/parsed-email/show/${key}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Failed to fetch email details");
      const data = await response.json();
      setEditingEmail(data.data); // Store fetched data
      setIsModalVisible(true);
    } catch (error) {
      message.error("Error fetching email details");
      console.error(error);
    }
  };
  const filteredEmails = emails.filter((email) => {
    const matchesSearch =
      debouncedSearchTerm === "" ||
      email.subject.toLowerCase().includes(debouncedSearchTerm);
    // const emailDate = moment(email.date, "YYYY-MM-DD", true);
    // const startDate =
    //   dateRange.length > 0 ? moment(dateRange[0], "YYYY-MM-DD", true) : null;
    // const endDate =
    //   dateRange.length > 0 ? moment(dateRange[1], "YYYY-MM-DD", true) : null;
    // if (!emailDate.isValid()) {
    //   return false;
    // }
    // if (!startDate || !endDate) return true;
    // const matchesDateRange = emailDate.isBetween(
    //   startDate,
    //   endDate,
    //   "days",
    //   "[]"
    // );
    return matchesSearch;
  });

  const renderEmailCell = (text, record) => (
    <div className="email-main-cell">
      <span
        className={`email-title ${record.read ? "email-read" : "email-unread"}`}
      >
        {text}
      </span>
      <span className="email-meta">
        {moment(record.date).format("DD MMMM YYYY")} | {record.due}
      </span>
    </div>
  );

  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, { method: "GET" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const columns = [
    {
      title: "",
      key: "select",
      align: "center",
      width: 50,
      onCell: () => ({
        "data-label": "Select",
        className: "email-select-cell",
      }),
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.key)}
          onChange={() => onSelectChange(record.key)}
        />
      ),
    },
    {
      title: "",
      dataIndex: "subject",
      key: "subject",
      onCell: () => ({ "data-label": "Email" }),
      render: (text, record) => renderEmailCell(text, record),
    },
    {
      title: "",
      key: "actions",
      align: "center",
      width: 100,
      onCell: () => ({
        "data-label": "Actions",
        className: "email-actions-cell",
      }),
      render: (record) => {
        const attachments = record?.attachment_urls || [];
        const attachmentCount = attachments.length;
        return (
          <div className="email-actions">
            {/* 📎 Attachments */}
            {attachmentCount > 0 && (
              <>
                <Tooltip title="View All Attachments">
                  <Button
                    icon={<PaperClipOutlined />}
                    onClick={() =>
                      setAttachmentModal({
                        visible: true,
                        attachments: attachments.map((a) => ({
                          name: a.attachment_name,
                          url: cleanUrl(a.attachment_url),
                        })),
                      })
                    }
                  >
                    {attachmentCount} {attachmentCount === 1 ? "File" : "Files"}
                  </Button>
                </Tooltip>
              </>
            )}
            <Tooltip
              title={record.event_id ? "You Can Edit From Calender" : "Edit"}
            >
              <Button
                disabled={record.event_id ? true : false}
                icon={<EditOutlined />}
                onClick={async () => {
                  handleEdit(record.key);
                  if (!record.is_read) {
                    await markNotificationAsRead(record.key);
                    setEmails((prev) =>
                      prev.map((email) =>
                        email.key === record.key
                          ? { ...email, is_read: true }
                          : email
                      )
                    );
                  }
                }}
                style={{
                  backgroundColor: "#A855F7",
                  color: "#fff",
                  border: "none",
                }}
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                className="deleteIcon"
                icon={<DeleteOutlined />}
                onClick={() => showDeleteModal([record.key])} // Pass as array
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const markNotificationAsRead = async (id) => {
    try {
      if (!token) throw new Error("No auth token found");

      const response = await fetch(
        `${URL}/v1/parsed-email/${id}/mark-as-read`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to mark notification as read");

      // setNotifications((prev) =>
      //   prev.map((notif) =>
      //     notif.id === id ? { ...notif, is_read: true } : notif
      //   )
      // );
      // fetchNotification(); // Refresh the notifications list
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };
  return (
    <>
      {screenLoading ? (
        <Spin style={{ margin: "20px auto", display: "block" }} />
      ) : (
        <div className="email-assistant-page">
          <div className="email-header">
            <h2>Parsed Email</h2>
            <div className="email-header-actions">
              <Button
                onClick={() => getData(currentPage)}
                className="resetBtn1"
                icon={<ReloadOutlined />}
              ></Button>
              <Button
              className="edit-email-setup-btn"
                onClick={async () => {
                  await getKeywords(); // wait for fresh data
                  const details =
                    initialKeyworkdsData?.data?.email_assistant_setup_details;
                  const is_email_account_linked =
                    initialKeyworkdsData?.data?.is_email_account_linked === 0;
                  if (!details || is_email_account_linked) {
                    setEmailSetupStartStep(0);
                  } else if (details.authorization_status === 0) {
                    setEmailSetupStartStep(1);
                  } else {
                    setEmailSetupStartStep(2);
                  }
                  setManualEdit(true);
                  setModalVisible(true); // open only after data is updated
                }}
              >
                Edit Email Setup
              </Button>
            </div>
          </div>
          {/* Selection Summary & Bulk Actions */}
          <div className="emailFilterSelected">
            <div className="emailSelected email-select-summary">
              <div className="emailSelectAllBtn">
                <Checkbox
                  onChange={handleSelectAll}
                  checked={selectedRowKeys.length === emails.length}
                  indeterminate={
                    selectedRowKeys.length > 0 &&
                    selectedRowKeys.length < emails.length
                  }
                />
                <span className="titleSelectAll">Select all</span>
              </div>
              <span>
                {selectedRowKeys.length} of {emails.length} Selected
              </span>
              {selectedRowKeys.length > 0 && (
                <Button
                  className="deleteIcon"
                  icon={<DeleteOutlined />}
                  onClick={() => showDeleteModal(selectedRowKeys)} // Pass selected keys array
                  style={{padding: '5px'}}
                />
              )}
            </div>
            {/* Filters & Search */}
            <div className="emailFilter filter-dropdowns">
              <Dropdown menu={menuProps} trigger={["click"]}>
                <Button>
                  {selectedPriority} <DownOutlined />
                </Button>
              </Dropdown>
              <Dropdown menu={keywordsProps} trigger={["click"]}>
                <Button>
                  {selectedKeywords} <DownOutlined />
                </Button>
              </Dropdown>
              <RangePicker
                onChange={handleDateChange}
                disabledDate={disabledDate}
                className="capture-date-range"
                dropdownClassName="capture-range-picker-dropdown"
              />
            </div>
            <div className="reset email-reset-row reset-filter-btn">
            <Text onClick={resetFilters} className="resetBtn1">
              Reset Filters
            </Text>
          </div>
          </div>
          {/* Search Bar */}
          <div className="emailSearch">
            <Input
              placeholder="Find an Email"
              value={searchTerm}
              onChange={handleSearchChange}
              prefix={<SearchOutlined style={{ color: "#888" }} />}
              className=""
            />
          </div>

          {/* Email Table */}
          <div className="email-table-wrapper" style={{marginTop: '16px'}}>
            <Table
              className="hide-table-header email-listing-table"
              dataSource={filteredEmails}
              columns={columns}
              loading={{
                spinning: loading,
                indicator: <Spin size="large" />,
              }}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalEmails,
                showSizeChanger: false, // Hide page size dropdown
                showLessItems: true, // Keep pagination compact
                onChange: (page, pageSize) =>
                  handleTableChange({ current: page, pageSize }),
              }}
              rowKey={"key"}
              rowClassName={(record) => {
                // console.log(record);

                let classes = ["emailRows"];
                if (selectedRowKeys.includes(record.key))
                  classes.push("selected-row");
                if (!record.read) classes.push("unread-row");
                return classes.join(" ");
              }}
              onRow={(record) => ({
                onDoubleClick: async () => {
                  handleEdit(record.key); // existing function
                  if (!record.is_read) {
                    await markNotificationAsRead(record.key);
                    setEmails((prev) =>
                      prev.map((email) =>
                        email.key === record.key
                          ? { ...email, is_read: true }
                          : email
                      )
                    );
                  }
                },
              })}
            />
          </div>
          {modalVisible &&
            (manualEdit ||
              !(
                initialKeyworkdsData?.data?.email_assistant_setup_details
                  ?.authorization_status === 1 &&
                initialKeyworkdsData?.data?.email_assistant_setup_details
                  ?.notification_setup_status === 1 &&
                initialKeyworkdsData?.data?.email_assistant_setup_details
                  ?.children_setup_status === 1
              )) && (
              <NewEmailSetup
                visible={modalVisible}
                screenLoading={screenLoading}
                initialKeyworkdsData={initialKeyworkdsData}
                onClose={() => {
                  setModalVisible(false);
                  setManualEdit(false); // Reset after close
                }}
                startStep={emailSetupStartStep}
              />
            )}
          {isModalVisible && (
            <ViewEmail
              visible={isModalVisible}
              onCancel={handleCancelModal}
              onSave={handleSave}
              metaCalender={calenderMeta}
              email={editingEmail}
            />
          )}
          <DeleteConfirmationModal
            visible={isDeleteModalOpen}
            onConfirm={handleDeleteConfirm}
            onCancel={() => setIsDeleteModalOpen(false)}
          />

          <Modal
            title="Attachments"
            open={attachmentModal.visible}
            onCancel={() =>
              setAttachmentModal({ visible: false, attachments: [] })
            }
            footer={null}
          >
            {attachmentModal.attachments.map((file, idx) => (
              <Button
                key={idx}
                type="default"
                icon={<DownloadOutlined />}
                style={{ marginBottom: 8, width: "100%" }}
                onClick={() => handleDownload(file.url, file.name)}
              >
                Download{" "}
                {file.name.length > 20
                  ? `${file.name.slice(0, 20)}...`
                  : file.name}
              </Button>
            ))}
          </Modal>
        </div>
      )}
    </>
  );
};

export default EmailListing;
